<template>
  <div class="xueshu">
    <div class="xuehu-title">
      <titleCard title="Academic Promotion"></titleCard>
    </div>
    <div class="xueshu-content">
      <div class="left animate__animated wow animate__fadeInLeft">
        Focus on nephrology and dialysis, and on providing academic promotion services for pharmaceutical companies with a national sales network, organize academic conferences of various scales and forms, coordinate experts, and promote the cooperation among relevant medical and pharmaceutical government institutions and civil organizations.
        <br> <br> 
        Improve the visibility and reputation of the company with its non-profit undertakings and academic achievements, so that a solid and long-term mutually beneficial relationship between the company and its target customers to be established, and the long-term strategic goals to be achieved.
      </div>
      <div class="right animate__animated wow animate__fadeInRight">
        <img src="../../assets/image/Science/xueshu/xueshu1.webp" alt="">
      </div>
    </div>
    <div class="xueshu-boxs">
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.2s">
        <div class="top"><img src="../../assets/image/Science/xueshu/xueshu2.webp" alt=""></div>
        <div class="bottom">Online Meeting</div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.4s">
        <div class="top"><img src="../../assets/image/Science/xueshu/xueshu3.webp" alt=""></div>
        <div class="bottom">Offline Meeting </div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.6s">
        <div class="top"><img src="../../assets/image/Science/xueshu/xueshu4.webp" alt=""></div>
        <div class="bottom">Special Lecture</div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="1.8s">
        <div class="top"><img src="../../assets/image/Science/xueshu/xueshu5.webp" alt=""></div>
        <div class="bottom">Live Case</div>
      </div>
      <div class="box animate__animated wow animate__fadeInDown" data-wow-duration="2.0s">
        <div class="top"><img src="../../assets/image/Science/xueshu/xueshu6.webp" alt=""></div>
        <div class="bottom">News</div>
      </div>
    </div>
    <!-- 往期项目展示 -->
    <div class="wangqi">
      <div class="title">
        <titleCard title="Past Projects"></titleCard>
      </div>
      <div class="wangqi-content pd animate__animated wow animate__fadeInRight">
        <div class="title">"CKD Diagnosis and Treatment Standard & Demonstration" project</div>
        <div class="lunbo">
          <div class="swiper-container">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px) !important">
              <div class="swiper-slide" v-for="(item,index) in lunboList1" :key="index">
                <div class="pic">
                  <img :src="item.pic" alt="">
                </div>
                <div class="txt">{{item.txt}}</div>
              </div>

            </div>
            <!-- Add Scrollbar -->
            <div class="swiper-scrollbar"></div>
          </div>
        </div>
      </div>
      <div class="wangqi-content animate__animated wow animate__fadeInRight">
        <div class="title">Pharmaceutical Project of "Your Kidney Loves Right Medicine"</div>
        <div class="lunbo">
          <div class="swiper-container">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px) !important">
              <div class="swiper-slide" v-for="(item,index) in lunboList2" :key="index">
                <div class="pic">
                  <img :src="item.pic" alt="">
                </div>
                <div class="txt">
                  {{item.txt}}
                </div>
              </div>

            </div>
            <!-- Add Scrollbar -->
            <div class="swiper-scrollbar"></div>
          </div>
        </div>
      </div>
    </div>
    <footerCard name="Mr Ji" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'
// 局部引入swiper
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';
export default {
  data() {
    return {
      lunboList1: [{
        pic: require('../../assets/image/Science/xueshu/lunbo/lunbo1.webp'),
        txt: '8 Offline Trainings in 2020'
      }, {
        pic: require('../../assets/image/Science/xueshu/lunbo/lunbo2.webp'),
        txt: '8 Onine News Releases in 2021'
      },
    ],
      lunboList2: [{
        pic: require('../../assets/image/Science/xueshu/lunbo/lunbo3.webp'),
        txt: 'Promotion in 2021'
      }, {
        pic: require('../../assets/image/Science/xueshu/lunbo/lunbo4.webp'),
        txt: '1 Offline Initiating Meeting, 2 Offline Exchange Meetings, 4 Online Exchange Meetings'
      },
      ]
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {
    new Swiper('.swiper-container', {
      scrollbar: '.swiper-scrollbar',
      scrollbarHide: false,
      slidesPerView: 'auto',
      // centeredSlides: true,
      spaceBetween: 30,
      grabCursor: true,
    });
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.xueshu {
  .xuehu-title {
    padding: 1rem 0 1.5789rem 0;
  }
  .xueshu-content {
    display: flex;
    margin-bottom: 3.1579rem;
    align-items: center;
    justify-content: center;
    height: 4.6316rem;
    @media screen and (max-width: 540px) {
      display: block;
      padding: 0 16px;
      height: 100%;
      margin-bottom: 20px;
    }
    .left {
      color: #272b2d;
      line-height: 0.4211rem;
      font-size: 0.2316rem;
      width: 8.0526rem;
      box-sizing: border-box;
      padding-right: 1.2211rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        padding: 0 5px;
        font-size: 15px;
        line-height: 26px;
      }
    }
    .right {
      width: 8.0526rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        margin-top: 15px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .xueshu-boxs {
    display: flex;
    height: 7.8947rem;
    background-color: #fbfbfb;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 540px) {
      justify-content: center;
      flex-wrap: wrap;
      height: 100%;
    }
    .box {
      height: 4.6316rem;
      width: 3.1579rem;
      margin: 0 0.1579rem;
      @media screen and (max-width: 540px) {
        height: 162px;
        flex-basis: 122px;
        flex-shrink: 0;
        margin: 0 5px;
        margin-bottom: 16px;
      }
      .top {
        height: 3.7368rem;
        @media screen and (max-width: 540px) {
          height: 80%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bottom {
        @media screen and (max-width: 540px) {
          height: 20%;
          line-height: 32px;
          font-size: 12px;
        }
        height: 0.8947rem;
        line-height: 0.8947rem;
        background-color: #0ca6eb;
        color: #fff;
        font-size: 0.2316rem;
        text-align: center;
      }
    }
  }
  .wangqi {
    .title {
      padding: 1.2632rem 0 1.1579rem 0;
    }
    .pd {
      padding-bottom: 1.0526rem !important;
    }
    .wangqi-content {
      padding-left: 1.6842rem;
      padding-bottom: 1.5789rem;
      .title {
        padding-bottom: 0.7579rem;
        font-size: 0.3158rem;
        color: #333333;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          text-align: center;
        }
      }
      .lunbo {
        height: 6.9474rem;
        @media screen and (max-width: 540px) {
          height: 210px;
        }
        .swiper-container {
          height: 100%;
          width: 100%;
        }
        .swiper-wrapper .swiper-slide {
          width: 10.5263rem;
          height: 6.5684rem;
          @media screen and (max-width: 540px) {
            height: 190px;
            width: 300px;
          }
          background-color: #fbfbfb;
          text-align: center;
          .pic {
            padding: 0.3158rem 0.4842rem 0.2632rem 0.4842rem;
            height: 5.5579rem;
            box-sizing: border-box;
            @media screen and (max-width: 540px) {
              height: 160px;
            }
            border-bottom: 1px solid #e6e6e6;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            color: #6a7073;
            padding-top: 0.3368rem;
            font-size: 0.3158rem;
            overflow: hidden;
            @media screen and (max-width: 540px) {
              font-size: 12px;
            }
          }
        }
        .swiper-scrollbar {
          left: 0;
          height: 0.0947rem;
          border-radius: 0;
        }
        /deep/.swiper-scrollbar-drag {
          background: #0ca6eb;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
